<template>
  <div class="cloud-big-data">
    <Header />
    <div class="container mx-auto px-4 pt-24 pb-16">
      <h1 class="text-4xl font-bold mb-8 text-center">云计算与大数据 - 赋能数字化转型</h1>
      
      <div class="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">云计算与大数据的领导者</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯在云计算与大数据领域拥有深厚的技术积累和丰富的行业经验，提供全方位的云计算和大数据解决方案。我们的产品和服务覆盖了云计算基础设施、大数据分析平台、AI应用等多个领域，助力企业实现数字化转型和智能化升级。
          </p>
          <p class="text-gray-700 mb-4">
            截至2025年，chmura云通讯云计算与大数据业务已服务超过200家政企客户，覆盖政府、金融、医疗、教育、制造、能源等多个行业。我们的云计算平台拥有超过1万台服务器，大数据处理能力达到每秒10亿条记录。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">核心产品与服务</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">云计算基础设施</h3>
              <p class="text-gray-700">提供私有云、公有云、混合云等多种部署方式，满足不同规模企业的云计算需求。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">大数据分析平台</h3>
              <p class="text-gray-700">基于AI的数据分析工具，支持数据挖掘、机器学习、深度学习等功能，帮助企业实现智能化决策。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">AI应用解决方案</h3>
              <p class="text-gray-700">提供图像识别、自然语言处理、语音识别等AI应用解决方案，助力企业提升业务效率。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">数据安全与隐私保护</h3>
              <p class="text-gray-700">全方位的安全防护方案，包括数据加密、访问控制、隐私保护等，保障企业数据的安全稳定。</p>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">行业应用案例</h2>
          <p class="text-gray-700 mb-4">
            在金融行业，chmura云通讯为某大型银行提供了云计算和大数据解决方案，实现了核心业务系统的上云部署和数据分析平台的建设。通过云计算平台，该银行的IT基础设施成本降低了30%，业务处理效率提升了50%。
          </p>
          <p class="text-gray-700">
            在医疗行业，我们为某大型医院提供了大数据分析平台，实现了医疗数据的整合和分析。通过该平台，医院能够快速准确地进行疾病诊断和治疗方案制定，医疗服务质量提升了40%。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">技术创新与未来发展</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯持续加大在云计算与大数据领域的研发投入，重点布局边缘计算、量子计算、AI技术等前沿领域。我们致力于构建更加智能、高效、安全的云计算和大数据平台，为用户提供更好的服务。
          </p>
          <p class="text-gray-700">
            同时，我们积极推动云计算与大数据技术的标准化和产业化，与合作伙伴共同探索新的应用场景和商业模式。我们的目标是成为全球领先的云计算与大数据解决方案提供商，助力数字经济的发展。
          </p>
        </div>

        <div class="text-center">
          <el-button type="primary" size="large" @click="$router.push('/contact')" class="bg-blue-600 hover:bg-blue-700">
            联系我们了解更多
          </el-button>
        </div>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'CloudBigData',
  components: {
    Header,
    Footer,
    BackToTop
  }
}
</script>

<style scoped>
.cloud-big-data {
  padding-top: 80px;
}
</style>
